import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { Gallery } from '../components/Gallery';
export function GalleryPage() {
  const {
    t
  } = useLanguage();
  return <motion.div initial={{
    opacity: 0,
    filter: 'blur(4px)'
  }} animate={{
    opacity: 1,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    filter: 'blur(4px)'
  }} transition={{
    duration: 0.6,
    ease: [0.4, 0, 0.2, 1]
  }} data-id="element-418">
      <PageHeader title={t.gallery.title} subtitle={t.gallery.subtitle} backgroundImage="https://images.unsplash.com/photo-1551218808-94e220e084d2?w=1200" data-id="element-419" />

      <Gallery data-id="element-420" />
    </motion.div>;
}